import { client } from "../client/client";

export const approveApplication = async (
  loanApplicationId,
  adminId,
  checklist,
  status,
  approvalLevel,
  description,
  additionalDocuments
) => {
  try {
    const response = await client.post(
      `/loan-applications/${loanApplicationId}/approve`,
      {
        loanApplicationId: loanApplicationId,
        adminId: adminId,
        checklist: checklist,
        status: status,
        approvalLevel: approvalLevel,
        description: description,
        additionalDocuments: additionalDocuments,
      }
    );
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
